import API from '../../../constants/api';

export const FETCH_PRODUCT_TAG_LIST_REQUEST = '@@productTag/FETCH_PRODUCT_TAG_LIST_REQUEST';
export const FETCH_PRODUCT_TAG_LIST_FAILURE = '@@productTag/FETCH_PRODUCT_TAG_LIST_FAILURE';
export const FETCH_PRODUCT_TAG_LIST_SUCCESS = '@@productTag/FETCH_PRODUCT_TAG_LIST_SUCCESS';

export const CREATE_PRODUCT_TAG_REQUEST = '@@productTag/CREATE_PRODUCT_TAG_REQUEST';
export const CREATE_PRODUCT_TAG_FAILURE = '@@productTag/CREATE_PRODUCT_TAG_FAILURE';
export const CREATE_PRODUCT_TAG_SUCCESS = '@@productTag/CREATE_PRODUCT_TAG_SUCCESS';

export const INACTIVATE_PRODUCT_TAG_REQUEST = '@@productTag/INACTIVATE_PRODUCT_TAG_REQUEST';
export const INACTIVATE_PRODUCT_TAG_SUCCESS = '@@productTag/INACTIVATE_PRODUCT_TAG_SUCCESS';
export const INACTIVATE_PRODUCT_TAG_FAILURE = '@@productTag/INACTIVATE_PRODUCT_TAG_FAILURE';

export const ACTIVATE_PRODUCT_TAG_REQUEST = '@@productTag/ACTIVATE_PRODUCT_TAG_REQUEST';
export const ACTIVATE_PRODUCT_TAG_SUCCESS = '@@productTag/ACTIVATE_PRODUCT_TAG_SUCCESS';
export const ACTIVATE_PRODUCT_TAG_FAILURE = '@@productTag/ACTIVATE_PRODUCT_TAG_FAILURE';

export const CLEAR_PRODUCT_TAG_STATE = '@@productTag/CLEAR_PRODUCT_TAG_STATE';

export const fetchPagesOfProductTag = (api = API.PRODUCT_TAGS.GENERIC, page, size, sortCol, sortOrder, filters) => ({
    type: FETCH_PRODUCT_TAG_LIST_REQUEST,
    api: `${api}?page=${page}&size=${size}&sortCol=${sortCol}&sortOrder=${sortOrder}
        &filter=${encodeURIComponent(JSON.stringify(filters))}`,
    page,
    size,
    sortCol,
    sortOrder,
});

export const createProductTagRequest = (productTag, isUpdate, successCallback, failureCallBack) => ({
    type: CREATE_PRODUCT_TAG_REQUEST,
    api: API.PRODUCT_TAGS.GENERIC,
    productTag,
    isUpdate,
    successCallback,
    failureCallBack,
});

export const inactivateProductTagRequest = (tagId, successCallback, failureCallBack) => ({
    type: INACTIVATE_PRODUCT_TAG_REQUEST,
    api: `${API.PRODUCT_TAGS.GENERIC}/${tagId}`,
    tagId,
    successCallback,
    failureCallBack,
});

export const activateProductTagRequest = (tagId, successCallback, failureCallBack) => ({
    type: ACTIVATE_PRODUCT_TAG_REQUEST,
    api: `${API.PRODUCT_TAGS.UN_RETIRE}/${tagId}`,
    tagId,
    successCallback,
    failureCallBack,
});

export const clearProductTagState = () => ({
    type: CLEAR_PRODUCT_TAG_STATE,
});
